import options from './options';

/**
 * State UI для взаимодейсвтиями с приложениями Vue
 */
const state = {
	/**
	 * CSS-классы модификаторы для документа страницы
	 */
	documentClassModificators: options.documentClassModificators,

	dateFormat: options.dateFormat,
	currency: options.currency,
	timezoneOffset: options.timezoneOffset,

	/**
	 * Device by size
	 *
	 * @see Core widthForMobile
	 */
	isMobile: false,

	/**
	 * Device by user agent
	 */
	isMobileUA: false,

	/**
	 * true, если плотность пикселей экрана больше 1
	 */
	isRetina: false,

	/**
	 * true, елси это приложение
	 */
	isApp: false,

	/**
	 * true при горизонтальном расположении устройства
	 */
	isLandscape: true,

	/**
	 * true при вертикальном расположении устройства
	 */
	isPortrait: false,

	/**
	 * Максимальная сторона страницы
	 */
	size: 0,

	/**
	 * true, если страница скрыта
	 *
	 * Не меняйте это значение вручную
	 */
	isHidden: false,
};

export default state;
